export default {
  statusRequest: {
    waiting: 'waiting',
    approved: 'approved',
    rejected: 'rejected'
  },
}
